<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '添加分区' : '修改分区'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        size="mini"
      >
        <el-form-item label="ID" prop="id">
          <el-input v-model="form.id" :disabled="!value.isCreate"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="自动解除隐藏">
          <el-date-picker v-model="form.autoVisibleAfter" type="datetime" :clearable="false" placeholder="选择时间"
            format="yyyy-MM-dd HH:mm" value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="游戏最低版本" prop="minVersion">
          <el-input v-model="form.minVersion" clearable placeholder="无版本要求可不填。如果填了，则低于该版本将无法看到当前分区"></el-input>
        </el-form-item>        
        <el-form-item label="对外地址（http）" prop="address">
          <el-input
            v-model="form.address"
            placeholder="举例：https://api.example.com/z1"
          ></el-input>
        </el-form-item>
        <el-form-item label="对内地址（grpc）" prop="internalAddress">
          <el-input
            v-model="form.internalAddress"
            placeholder="举例：localhost:11002"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      visible: true,
      form: {
        id: "",
        name: "",
        minVersion: "",
        address: "",
        internalAddress: "",
        status: "",
      },
      rules: {
        id: [{ required: true, message: " ", trigger: "blur" }],
        name: [{ required: true, message: " ", trigger: "blur" }],
        address: [{ required: true, message: " ", trigger: "blur" }],
        internalAddress: [{ required: true, message: " ", trigger: "blur" }],
      },
      statusOptions: [
        {
          value: 0,
          label: "隐藏",
        },
        {
          value: 1,
          label: "维护",
        },
        {
          value: 2,
          label: "空闲",
        },
      ],
    };
  },

  props: {
    value: Object,
  },

  created() {
    if (!this.value.isCreate) {
      this.form.id = this.value.oldData.id;
      this.form.name = this.value.oldData.name;
      this.form.address = this.value.oldData.address;
      this.form.internalAddress = this.value.oldData.internalAddress;
      this.form.status = this.value.oldData.status;
      this.form.minVersion = this.value.oldData.minVersion;
    } else {
      this.form.status = 0; // 默认“隐藏”状态
      if (this.value.oldData != null){
        this.form.address = this.value.oldData.address;
        this.form.proxyAddress = this.value.oldData.proxyAddress;
        this.form.internalAddress = this.value.oldData.internalAddress;
        this.form.minVersion = this.value.oldData.minVersion;
      }
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.addZone();
      } else {
        this.updateZone();
      }
    },

    /**
     * 新增分区
     */
    addZone() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let zoneId = Number(this.form.id);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/zone/add`,
            {
              zone: {
                id: zoneId,
                name: this.form.name,
                minVersion: this.form.minVersion,
                address: this.form.address,
                internalAddress: this.form.internalAddress,
                status: this.form.status,
                autoVisibleAfter:this.form.autoVisibleAfter,
              },
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          // 可能需要重新登录
          if (resData.code == 2004) {
            util.gotoLoginPage();
            return;
          }

          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    /**
     * 修改分区
     */
    updateZone() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/zone/update`,
            {
              zone: {
                id: this.value.oldData.id,
                name: this.form.name,
                minVersion: this.form.minVersion,
                address: this.form.address,
                internalAddress: this.form.internalAddress,
                status: this.form.status,
                autoVisibleAfter:this.form.autoVisibleAfter,
              },
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          // 可能需要重新登录
          if (resData.code == 2004) {
            util.gotoLoginPage();
            return;
          }

          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>